import { HttpHeaders } from '@angular/common/http';
var NoCacheHeadersInterceptorService = /** @class */ (function () {
    function NoCacheHeadersInterceptorService() {
    }
    NoCacheHeadersInterceptorService.prototype.intercept = function (req, next) {
        var authReq = req.clone({
            headers: new HttpHeaders({
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
            })
        });
        return next.handle(authReq);
    };
    return NoCacheHeadersInterceptorService;
}());
export { NoCacheHeadersInterceptorService };



// WEBPACK FOOTER //
// ./src/app/no-cache-headers-interceptor.service.ts.pre-build-optimizer.js